// ⬡B:ms_mac_core.tokens:CODE:ms_mac_persona_clone_fix:20260607⬡
// Ms.Ria design tokens — glass and smoke aesthetic.
// Source: apps/msria-home/src/Chat.jsx C object.

export const C = {
  ink:      '#08080a',
  glass:    'rgba(255,255,255,.055)',
  hair:     'rgba(214,217,224,.26)',
  platinum: '#e9ebf0',
  rose:     '#e8b4a0',
  rosed:    '#c98d76',
  bronze:   '#b08d57',
  burg:     '#5e2230',
  gold:     '#c9a24a',
  text:     '#f3f2ef',
  muted:    '#b9bcc6',
};